// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 221 ? "stores" : chunkId) + "." + {"157":"d395e4e9","221":"fcaf55a1","973":"315064f4"}[chunkId] + ".chunk.js";
};